import React, { useState, useEffect, useRef } from "react";
import {
  Page,
  Navbar,
  NavRight,
  Segmented,
  Button,
  Block,
  Tabs,
  Tab,
  Icon,
  Link,
  Popup,
  Input,
  f7,
  Toggle,
  ListItem,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "../globals";
import moment from "moment";
const PayInvoice = () => {
  const [data, setEventDetails] = useState([]);
  const [showOrderHis, setShowOrderHis] = useState([]);
  const [formData, setFormData] = useState([]);
  const [totalAmount, setTotalAmount] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [calculatedValues, setCalculatedValues] = useState({
    sub_total: 0,
    discount: 0,
    total_amt: 0,
    sales_tax: 0,
    total: 0,
  });

  const [isSalesTaxEnabled, setSalesTaxEnabled] = useState(true);
  useEffect(() => {
    const st_data = localStorage.getItem("order_data");
    const parsedData = JSON.parse(st_data);
    setFormData(parsedData);
  }, []);

  // useEffect(() => {
  //   const deliverData = formData.delivery_type == "Delivery" ? "1" : "2";
  //   setFormData({
  //     ...formData,
  //     delivery_type: deliverData,
  //   });
  // }, []);

  const ConfirmOrder = (e) => {
    e.preventDefault();
    const discountInput = document.querySelector("input[name='discount']");

    // Check if the discount input field is valid
    if (!discountInput.checkValidity()) {
      // If the input is invalid, show an error message and prevent further actions
      f7.toast
        .create({
          text: "Please enter a valid discount value.",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
    } else {
      if (isSubmitting) {
        return;
      }
      let deliverData;
      // = formData.delivery_type == "Delivery" ? "1" : "2";
      if (formData.delivery_type == "Delivery") {
        deliverData = "1";
      } else if (formData.delivery_type == "1") {
        deliverData = "1";
      } else if (formData.delivery_type == "2") {
        deliverData = "2";
      } else {
        deliverData = "2";
      }
      const updatedFormData = {
        ...formData,
        delivery_type: deliverData,
      };

      setIsSubmitting(true);

      axios
        .post(API_BASE_URL + "orderaddbyrest", updatedFormData, {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        })
        .then((response) => {
          if (response.data.status === "failure" && response.data.message) {
            // const errorMessage = response.data.message;
            // const errorMessage = (JSON.stringify(response.data.message));
            const errorMessages = Object.values(response.data.message);
            f7.toast
              .create({
                text: errorMessages,
                position: "top",
                cssClass: "bg-color-red",
                closeTimeout: 3000,
              })
              .open();
            setIsSubmitting(false);
          } else {
            console.log(response.data.order_id);
            f7.views.main.router.navigate({
              name: "payment",
              params: {
                id: response.data.order_id,
              },
            });

            f7.toast
              .create({
                text: "Order has been created..!",
                position: "top",
                cssClass: "bg-color-teal",
                closeTimeout: 3000,
              })
              .open();
            localStorage.removeItem("order_data");
            // setFormData([]);
          }
        })
        .catch((error) => {
          console.log(error);
          f7.toast
            .create({
              text: "Something went wrong..!",
              position: "top",
              cssClass: "bg-color-red",
              closeTimeout: 3000,
            })
            .open();
          setIsSubmitting(false);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const Payment = (order_id) => {
    console.log(order_id);
    f7.views.main.router.navigate({
      name: "payment",
      params: {
        id: order_id,
      },
    });
  };
  const discountAddItem = (e) => {
    var discount = parseFloat(e.target.value);
    var sub_amt = parseFloat(formData.sub_total);
    var total_amount = sub_amt - discount;
    // setTotalAmount(total_amount);
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      ["grand_total"]: total_amount > 0 ? total_amount : formData.sub_total,
    });
  };
  useEffect(() => {
    if (formData.tax == 0) {
      setSalesTaxEnabled(false);
    }
  }, [formData]);
  useEffect(() => {
    const sub_total = formData.sub_total;
    const discount = formData.discount > 0 ? formData.discount : 0;
    const total_amt = sub_total - discount > 0 ? sub_total - discount : 0;
    let sales_tax = 0;
    if (isSalesTaxEnabled) {
      sales_tax = parseFloat(total_amt * (formData.sales_tax / 100)).toFixed(2);
    } else {
      sales_tax = 0;
    }
    const total = parseFloat(total_amt) + parseFloat(sales_tax);
    // console.log(sales_tax);

    // Update state with calculated values
    setCalculatedValues({
      sub_total,
      discount,
      total_amt,
      sales_tax,
      total,
    });
    formData.tax = sales_tax;
    formData.grand_total = total;
  }, [
    formData.sub_total,
    formData.discount,
    formData.sales_tax,
    isSalesTaxEnabled,
  ]);
  const renderIcon = (orderStatus) => {
    if (orderStatus === 1) {
      return (
        <img
          class="img-fluid icon step-1"
          src={require("./../images/svg/cube.svg").default}
          alt="cube"
        />
      );
    } else if (orderStatus === 2) {
      return (
        <img
          class="img-fluid icon step-3"
          src={require("./../images/svg/bike.svg").default}
          alt="bike"
        />
      );
    } else if (orderStatus === 3) {
      return (
        <img
          class="img-fluid icon step-2"
          src={require("./../images/svg/manage-payment.svg").default}
          alt="3d-cube"
        />
      );
    } else if (orderStatus === 4) {
      return (
        <img
          class="img-fluid icon step-4"
          src={require("./../images/svg/done.svg").default}
          alt="done"
        />
      );
      // } else if (orderStatus === 5) {
      //   return <img class="img-fluid icon step-1 bg-danger" src={require('./../images/svg/empty-cart.svg').default} alt="done"/>;
    } else {
      return null; // Render a default icon or nothing if no matching status
    }
  };

  const formatDate = (date) => {
    var e_date = new moment(date);
    const formattedDateStr = e_date.format("MM-DD-YYYY h:mm A");
    return formattedDateStr;
  };

  const handleSalesTaxToggle = () => {
    setSalesTaxEnabled(!isSalesTaxEnabled);
  };

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>{" "}
                  <span className="text-dark d-none d-md-block">Back</span>
                </Link>
                <h2>Order</h2>
              </div>
            </div>
          </header>
          <section className="profile-form mt-3">
            <div className="custom-container p-0">
              <table className="table mt-2 text-2">
                <tbody>
                  <tr>
                    <td width={"40%"}>Event Name: </td>
                    <td className="text-capitalize">
                      <b>{formData.event_name}</b>
                    </td>
                  </tr>
                  <tr>
                    <td width={"40%"}>Event Date : </td>
                    <td>{formatDate(formData.event_date)} </td>
                  </tr>
                  <tr>
                    <td>Event Size: </td>
                    <td>
                      {formData.event_adult_size !== null &&
                        formData.event_adult_size !== undefined && (
                          <span>
                            Adults -{" "}
                            <strong>{formData.event_adult_size}</strong>
                          </span>
                        )}
                      {formData.event_kids_size !== null &&
                        formData.event_kids_size !== undefined && (
                          <span>
                            , Kids - <strong>{formData.event_kids_size}</strong>
                          </span>
                        )}
                    </td>
                  </tr>
                  {/* <tr>
                      <td>Food Need By Time: </td>
                      <td>{formData.event_by_time}</td>
                    </tr> */}
                  <tr>
                    <td>Event Address: </td>
                    {formData.delivery_type == "1" ||
                    formData.delivery_type == "Delivery" ? (
                      <td>
                        {formData?.add_lin_1} {formData?.add_lin_2}{" "}
                        {formData?.state_name}
                        {/* {formData?.state} */} {formData?.zip_code}
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                  <tr>
                    <td>Deliver Type: </td>
                    <td>
                      {" "}
                      {formData.delivery_type == "1"
                        ? "Delivery"
                        : formData.delivery_type == "2"
                        ? "Pickup"
                        : formData.delivery_type}
                    </td>
                  </tr>
                  <tr>
                    <td>Event Notes: </td>
                    <td>{formData.event_note}</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="fw-bold dark-text p-1">Customer Details</h3>
              <table className="table text-2">
                <tbody>
                  <tr>
                    <td>Customer Name: </td>
                    <td>
                      {formData.cust_fname} {formData.cust_lname}
                    </td>
                  </tr>
                  <tr>
                    <td>Email: </td>
                    <td>{formData.cust_email}</td>
                  </tr>
                  <tr>
                    <td>Phone: </td>
                    <td>{formData.cust_contact_no}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="custom-container p-1">
              <h3 className="fw-bold dark-text">Menu Items</h3>
              <table className="table text-2">
                <tbody>
                  <tr>
                    <td className="text-center">No</td>
                    <td>Item name</td>
                    <td>Price</td>
                    <td>Qty</td>
                    <td className="text-end">Total</td>
                  </tr>
                  {formData && formData.items
                    ? formData.items.map((rest_event, index) => (
                        <tr>
                          <td className="text-center">{index + 1}</td>
                          <td>
                            <h5 className="dark-text fw-bold mb-1">
                              {rest_event.menu_name}
                            </h5>
                          </td>
                          <td>
                            ${parseFloat(rest_event.menu_amount).toFixed(2)}
                          </td>
                          <td>{rest_event.tray_size_id}</td>
                          <td className="text-end">
                            ${parseFloat(rest_event.total_amount).toFixed(2)}
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
            <div className="custom-container p-2">
              <table
                className="col-5"
                style={{ float: "right", marginRight: "0px" }}
              >
                <tr>
                  <td className="dark-text fw-bold mb-1">Sub Total </td>
                  <td className="text-end">
                    {" "}
                    ${parseFloat(calculatedValues?.sub_total)?.toFixed(2)}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  {/* <td className="dark-text fw-bold mb-1">Discount </td><td className='text-end'> ${formData.discount > 0 ? formData.discount:0 }</td><td> </td> */}
                  <td className="dark-text fw-bold mb-1">Discount </td>
                  <td className="text-end">
                    {" "}
                    ${parseFloat(calculatedValues?.discount)?.toFixed(2)}
                  </td>
                  <td> </td>
                </tr>
                <tr>
                  {/* <td className="dark-text fw-bold mb-1">Sales Tax </td><td className='text-end'> ${formData.discount > 0 ? formData.grand_total - formData.discount :formData.grand_total}</td><td></td> */}
                  <td className="dark-text fw-bold mb-1">
                    Sales Tax ({formData.sales_tax}%)
                  </td>
                  <td className="text-end"> ${calculatedValues.sales_tax}</td>
                  <td></td>
                </tr>
                <tr>
                  <td className="dark-text fw-bold mb-1">Total </td>
                  <td className="text-end">
                    {" "}
                    ${parseFloat(calculatedValues?.total)?.toFixed(2)}
                  </td>
                  <td></td>
                </tr>
              </table>
              <div className="form-group col-4">
                <div className="mb-2 mt-2  p-2">
                  <ListItem>
                    <span className="p-2">Sales Tax</span>
                    <Toggle
                      onChange={handleSalesTaxToggle}
                      checked={isSalesTaxEnabled}
                      color="green"
                    />
                  </ListItem>
                </div>
                <label className="form-label fw-semibold">Add Discount</label>
                <div className="mb-4">
                  <Input
                    type="text"
                    // required
                    validate
                    // pattern="[0-9\s]{1,4}"
                    pattern="^[0-9]*\.?[0-9]+$"
                    errorMessage="Please enter correct value."
                    className="form-control"
                    placeholder="Discount "
                    name="discount"
                    onChange={discountAddItem}
                    value={formData.discount}
                  />
                </div>
              </div>
              <Button
                type="submit"
                className="btn theme-btn mt-0 w-100"
                onClick={ConfirmOrder}
                large
                disabled={isSubmitting}
              >
                {isSubmitting ? "Confirming..." : "Confirm Order"}
              </Button>
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
};

export default PayInvoice;
